import React from "react";
import { Tv } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SHOW, PHOTOS } from "@/lib/data";

const ShowPromo = () => {
  return (
    <section id="show" className="relative py-16 sm:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="relative rounded-[32px] overflow-hidden border border-[#D4AF37]/25 bg-gradient-to-br from-[#141d40] via-[#101730] to-[#0B1021]">
            <div
              className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[radial-gradient(circle,rgba(245,158,11,0.14),transparent_70%)] blur-2xl"
              aria-hidden="true"
            />
            <div className="relative">
              {/* The set at CBS Television City */}
              <div className="rounded-t-[24px] overflow-hidden border-x border-t border-[#D4AF37]/25">
                <img
                  src={PHOTOS.studioSet}
                  alt="The A View from the Top set at CBS Television City"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="caption-champagne px-4 sm:px-6 py-4 rounded-b-[24px] text-center">
                <p className="text-[10px] sm:text-[11px] uppercase tracking-[0.14em] sm:tracking-[0.22em] text-[#0B1021] leading-relaxed">
                  The set · CBS Television City
                </p>
                <p className="font-display italic text-sm sm:text-base text-[#0B1021]/80 mt-1">
                  "Change the story. Change the view. Change your life."
                </p>
              </div>

              <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-10 items-center pt-10 px-2 sm:px-4">
                <div>
                  <p className="eyebrow flex items-center gap-3">
                    <span className="hairline w-10 inline-block" /> The Live TV Show Taping
                  </p>
                  <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-5 text-[#FDFBF7] leading-tight">
                    You're not just attending.
                    <br />
                    <em className="text-gold-gradient italic">You're the episode.</em>
                  </h2>
                  <p className="mt-6 text-[#9CA3AF] font-light leading-relaxed max-w-xl">
                    For one January night, Susan's show{" "}
                    <span className="text-[#F3D068]">A View from the Top</span> leaves its
                    soundstage at CBS Television City and records the LIVE event version in front
                    of you at the Saban — taped for its New Year 2027 special premiere. Real
                    conversations, real spirit messages. Seats in the room become seats in the
                    story.
                  </p>
                  <a
                    href={SHOW.studioTicketsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="show-studio-tickets"
                    className="btn-gold rounded-full px-6 py-3 text-sm font-bold inline-flex items-center gap-2.5 mt-4"
                  >
                    <Tv size={16} /> CBS Studio Audience Tickets
                  </a>
                  <p className="text-xs text-[#8A99B5] mt-4 font-light">
                    For live audience tickets to the show at CBS Television City:{" "}
                    <span className="text-[#F3D068]">myinfinite.app/show</span>
                  </p>
                </div>

                <div className="space-y-5">
                  <div className="rounded-[24px] overflow-hidden border border-[#D4AF37]/25">
                    <img
                      src={PHOTOS.studioAudience}
                      alt="Susan on the A View from the Top set at CBS Television City, facing the studio audience"
                      className="w-full h-auto object-cover"
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ShowPromo;
